import React, { useEffect, useState } from "react";
import Loader from '../../Loader/Loader';
import axios from 'axios';
import "./StatementOfAccount.css";
/*import FilterAccount from "./BorrowerSummary/FilterAccount/FilterAccount";*/
import BorrowerTable from "./BorrowerSummary/BorrowerTable/BorrowerTable";
/*import ProductAccountTable from "./BorrowerSummary/ProductAccountTable/ProductAccountTable";*/
/*import ViewScheduleTable from "./BorrowerSummary/ViewScheduleTable/ViewScheduleTable";*/
import Footer from "./Footer/Footer";
import { deserialize } from 'jsonapi-fractal';
import { isMobile } from 'react-device-detect';
import moment from 'moment';

const StatementOfAccount = ()=>{
  const [loader,setLoader] = useState(false);
  const [borrowerAccount,setBorrowerAccount] = useState(null);
  const [clientToken,setClientToken] = useState(null);
  const [userId,setUserId] = useState(null);
  const [errorMsg,setErrorMsg] = useState(null);
  const [loanIndex,setLoanIndex] = useState("");
  const [disableDownload,setDisableDownload] = useState(false);
  const [deviceType,setDeviceType] = useState(false);
  const [startDate, setStartDate] = useState(moment().subtract(30, 'DAY').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [triggerDate, setTriggerDate] = useState(null);

 /* const changesLoan = (e) => {
    setLoanIndex(e.target.value);
  };*/

  const returnborrowerAccount = () => {
    var ba = [];
    if(borrowerAccount) {
        if(loanIndex === "") {
          return borrowerAccount;
        }
        else {
          ba.push(borrowerAccount[loanIndex])
          return ba;
        }
    }
    else {
      return [];
    }
  }

   const downloadSOA = () => {

        setDisableDownload(true)

        axios.get(`${process.env.REACT_APP_API_URL}/api/v1/disbursed_loan_accounts/download.pdf?user_id=${userId}&ledger_start_date=${startDate}&ledger_end_date=${endDate}`,
        {
            headers: {
                'token': clientToken,
                "APP-id": process.env.REACT_APP_APP_ID,
            },
            responseType: 'arraybuffer',
        })
        .then(handleResponse)
        .catch((err) => {
            var error = err.response.data;
            var arr = new Uint8Array(error);
            var str = String.fromCharCode.apply(String, arr);

            if(/[\u0080-\uffff]/.test(str)){
                console.log("this string seems to contain (still encoded) multibytes");
                throw new Error("this string seems to contain (still encoded) multibytes");
            }

           const obj = JSON.parse(str);
           window.alert(obj.errors[0].code+": "+obj.errors[0].detail)
            setDisableDownload(false)

        });
       };

    const handleResponse = (response) =>{
        const blob = new Blob([response.data], { type: 'application/pdf; charset=utf-8' });

        var soaFileURL = URL.createObjectURL(blob);
        var fileLink = document.createElement('a');
        fileLink.href = soaFileURL;
        fileLink.download = "UserID-"+userId;
        fileLink.click();

        setDisableDownload(false)

    }

  const handleSubmit = (e) => {
      e.preventDefault();
      setTriggerDate(startDate+endDate)
  }

  useEffect(()=>{
    
    if(window && window.location.search) {
        
        const urlParams = new URLSearchParams(window.location.search);
        
        const { REACT_APP_USER_ID, REACT_APP_SECRET_KEY, REACT_APP_TYPE,REACT_APP_APP_ID,REACT_APP_AUTH_API_URL } = process.env;

        if(urlParams.get('token')) {

            let urlToken = urlParams.get('token');
            setLoader(true)

            const authData = {
                user_id: REACT_APP_USER_ID,
                secret_key: REACT_APP_SECRET_KEY,
                type: REACT_APP_TYPE
            };


            axios.post(`${REACT_APP_AUTH_API_URL}/api/v1/auth`,authData,
            {
                headers: {
                    "APP-id": REACT_APP_APP_ID,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
            })
            .then((res)=>{
              
              let device = urlParams.get('device');

              if(device === "mobile"){
                 setDeviceType(true)
              }
              let clientTokenTemp = res.data.response.auth.token;
              setClientToken(clientTokenTemp);

                axios.get(`${process.env.REACT_APP_API_URL}/api/v1/disbursed_loan_accounts/get_soa_user_id?token=${urlToken}`,
                {
                    headers: {
                        'token': clientTokenTemp,
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                })
                .then((resUserid)=>{
                  
                  let user_id = resUserid.data.user;
                  setUserId(user_id);
                  axios.get(`${process.env.REACT_APP_API_URL}/api/v1/disbursed_loan_accounts?q[user_id_eq]=${user_id}`,
                  {
                      headers: {
                          'token': clientTokenTemp,
                          'Content-Type': 'application/json',
                          'Accept': 'application/json'
                      },
                  })
                  .then((res)=>{
                    
                    const data = deserialize(res.data)
                    setBorrowerAccount(data);
                    setLoader(false)
                  });


                }).catch(err => {
                  setErrorMsg(err.response.data.errors[0].code+": "+err.response.data.errors[0].detail);
                  setLoader(false)
                });

                //setErrorMsg
            });
        }
    }  


  },[]);

  return (
    <>
    <div className="container-fluid padd0 statement-of-account ">
      <div className="col-md-12  d-flex statement-of-account-header align-items-center pr-4 pl-4">
        <div className="col-md-6 padd0">STATEMENT OF ACCOUNTS</div>
        <div className="col-md-6 padd0 text-right">
          <img
            src="https://mintifi.com/media/logo.png"
            alt="logo"
            className="pt-4 mb-4 img-fluid"
          />
        </div>
      </div>
      <div style={{ backgroundColor: "#E9E9E9" }} className="pt-2"></div>
      {loader &&
        <div className="NoData text-center"><Loader /></div>
      }
      {!loader && !errorMsg && !borrowerAccount &&
        <div className="NoData text-center">We are unable to process your request.</div>
      }
      {!loader && errorMsg &&
        <div className="NoData text-center">{errorMsg}</div>
      }
      {borrowerAccount &&
        <>
      <div className="col-md-12 greeenColor">
        <div className="row statement-of-account-form pl-md-2">
          <div className="col-md-12">
            <div className="row" >
              <div className="col-md-6 pt-4 d-flex align-items-center" style={{flexDirection: isMobile ? "column" : "row"}}>
                <label className="leadlabel" style={{marginBottom: '0px'}}>Borrower Details</label>
           <div>
           <form onSubmit={handleSubmit}>
                <div style={{ display: isMobile ? "block" : "flex",marginLeft:"10px"}}>
                  <div style={{ display:"flex"}}>
                  <div style={{display:"flex",flexDirection:"column",marginLeft:"20px"}}>
                    <label style={{cursor: "pointer",marginBottom:"2px",fontSize:"12px"}} htmlFor="start">Start Date</label>
                     <input
                        type="date"
                        placeholder="DD/MM/YY"
                        defaultValue={startDate}
                        max={endDate}
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                     />
                  </div>
                  <div style={{display:"flex", flexDirection:"column", marginLeft:"20px"}}>
                   <label htmlFor="end" style={{cursor: "pointer",marginBottom:"2px",fontSize:"12px"}}>End Date</label>
                    <input
                      type="date"
                      placeholder="DD/MM/YY"
                      max={endDate}
                      defaultValue={endDate}
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                  </div>
                  <div style={{marginTop:"25px",marginLeft: isMobile ? "30%" : "0"}}>
                    <button type="submit" onClick={handleSubmit} style={{padding:"8px 12px", backgroundColor:"#60A889",color:"white",border:"none", borderRadius:"5px", marginLeft:"20px"}}>FILTER</button>
                  </div>
               </div>
             </form>
           </div>
              </div>
            {!isMobile && !deviceType &&
              <div className="col-md-6 pt-3 pr-4 d-flex align-items-center justify-content-end">
                <button type="button"  disabled={disableDownload} className="btn download-btn-SOA" onClick={() => downloadSOA() }>Download SOA<img src="/images/download.svg" alt="icon" className="ml-2 mb-1 dispNone" /></button>
              </div>
            }
            </div>
          </div>

          <div className="col-md-12 spacingTop">
            <div className="row" >
              <div className="col-md-6 mobileSpace">
                  <div className="row" >
                      <div className="col-md-3">
                        <label className="borrower-details-lable">Name</label>
                      </div>
                      <div className="col-md-9" style={{color: '#707070'}}>
                        {borrowerAccount[0].user_name}
                      </div>
                  </div>
              </div>
              <div className="col-md-6 mobileSpace">
                  <div className="row" >
                      <div className="col-md-3">
                        <label className="borrower-details-lable">Mobile No</label>
                      </div>
                      <div className="col-md-9" style={{color: '#707070'}}>
                        {borrowerAccount[0].phone_number}
                      </div>
                  </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 mt-1 mb-4">
            <div className="row">
              <div className="col-md-6 mobileSpace">
                  <div className="row" >
                      <div className="col-md-3">
                        <label className="borrower-details-lable">Name of Firm</label>
                      </div>
                      <div className="col-md-9 text-capitalize" style={{color: '#707070'}}>
                        {borrowerAccount[0].company_name}
                      </div>
                  </div>
              </div>
              <div className="col-md-6 mobileSpace">
                  <div className="row" >
                      <div className="col-md-3">
                        <label className="borrower-details-lable">Email Id</label>
                      </div>
                      <div className="col-md-9" style={{color: '#707070', wordBreak:'break-all'}}>
                        {borrowerAccount[0].borrower_email}
                      </div>
                  </div>
              </div>
            </div>
          </div>
            {isMobile && !deviceType &&
              <div className="col-md-6 pt-3 pr-4 pb-3">
                <button type="button" disabled={disableDownload} className="btn download-btn-SOA col-12" onClick={() => downloadSOA() }>Download SOA<img src="/images/download.svg" alt="icon" className="ml-2 mb-1 dispNone" /></button>
              </div>
            }

         {/*<div className="col-md-12">
             <div className="row">
               <div className="col-md-12">
                 <label className="leadlabel">SELECT</label>
               </div>
             </div>
           </div>*/}

          {/*<div className="col-md-12">
              <div className="row">
                <div className="col-md-3">
                  <label>Loan Application</label>
                </div>
                <div className="col-md-9">
                  <select className="col-md-9 select-custom-form" onChange={(e) => changesLoan(e)}>
                    <option value="">All</option>
                    {borrowerAccount && borrowerAccount.map((index,key) =>
                      <option key={key} value={key}>{index.id}</option>
                    )}
                  </select>
                </div>
              </div>
            </div>*/}

          
        </div>
      </div>

      <BorrowerTable triggerDate={triggerDate} startDate={startDate} endDate={endDate} borrowerAccount={returnborrowerAccount()} userId={userId} clientToken={clientToken} />
    </>
    }
      <Footer />
    </div>
</>
  );
}

export default StatementOfAccount;
